import czxy from './czxy.json';
import lang from './lang.json';

export default {
    ...czxy,
    ...lang,
}


// WEBPACK FOOTER //
// ./src/assets/i18n/en/index.js